import axios from "axios";
import { ENDPOINTS } from "../apiConstants";
import { getConfigPatch } from "../getConfig";

export const approveInvoice = async (invoice: { id: number; brand_id: number; period: string }, brand: string) => {
  if (
    !window.confirm(
      `Approve both invoice parts (fee and reward reimbursement) for ${brand}, ${invoice.period}? Only a super admin can approve invoices.`
    )
  ) {
    return null;
  }
  const res: any = await axios.patch(
    `${ENDPOINTS.CLO_INVOICES}/${invoice.id}`,
    { action: "approve" },
    { headers: getConfigPatch() }
  );
  return res.data as { brandId: number; period: string; approved: any };
};
